import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
  min-width: 220px;
  font-family: inherit;
`;

export const SelectInput = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 10px;
  min-height: 40px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.white};
  color: ${({ theme }) => theme.textColor};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};

  &:focus-within,
  &:hover {
    border-color: ${({ theme }) => theme.primaryColor};
  }
`;

export const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  flex: 1;
  min-width: 0;
`;

export const Placeholder = styled.span`
  color: ${({ theme }) => theme.darkGray};
  font-size: 14px;
`;

export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 8px;
  background-color: ${({ theme }) => theme.primaryColor};
  color: #fff;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
`;

export const ChipRemove = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  padding: 0;
  font-size: 11px;
  opacity: 0.85;

  &:hover {
    opacity: 1;
  }
`;

export const IconsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.textColor};
  flex-shrink: 0;
`;

export const ClearButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.darkGray};
  cursor: pointer;
  padding: 2px 4px;
  font-size: 14px;

  &:hover {
    color: ${({ theme }) => theme.dangerColor};
  }
`;

export const OptionsContainer = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  max-height: 260px;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.cardBackground};
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 4px;
  box-shadow: 0 2px 8px ${({ theme }) => theme.shadowColor};
  z-index: 50;
`;

export const Option = styled.div<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  gap: 10px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  color: ${({ theme }) => theme.textColor};
  background-color: ${({ isSelected, theme }) =>
    isSelected ? theme.expandedRowBackground : 'transparent'};

  &:hover {
    background-color: ${({ theme }) => theme.lightGrayHover};
  }
`;

export const OptionLabel = styled.span`
  flex: 1;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  /* sobrescreve o input global do projeto */
  width: 16px;
  min-width: 16px;
  height: 16px;
  padding: 0;
  margin: 0;
  border: none;
  border-radius: 0;
  cursor: pointer;
  accent-color: ${({ theme }) => theme.primaryColor};
  flex-shrink: 0;
`;

export const NoOptions = styled.div`
  padding: 12px;
  text-align: center;
  color: ${({ theme }) => theme.darkGray};
`;

export const OptionsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  background-color: ${({ theme }) => theme.lightGrayColor};
`;

export const HeaderInfo = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.darkGray};
`;

export const HeaderAction = styled.button`
  background: none;
  border: none;
  padding: 2px 6px;
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.primaryColor};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
